const Service = () => {
  return <div>Here is Service page</div>;
};

export default Service;
